import AddAlertOutlinedIcon from "@mui/icons-material/AddAlertOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { SectionHeading } from "@/shared/ui";
import { ThresholdConfigCard } from "@/features/deployment-settings/components/threshold-config-card";
import type { ThresholdConfig } from "@/features/deployment-settings/model/admin-settings";

interface ThresholdConfigurationsSectionProps {
  configs: ThresholdConfig[];
}

export function ThresholdConfigurationsSection({ configs }: ThresholdConfigurationsSectionProps) {
  return (
    <Stack id="threshold-configs" spacing={2.5}>
      <Stack spacing={0.75}>
        <SectionHeading
          component="h2"
          icon={<AddAlertOutlinedIcon />}
          action={
            <Tooltip title="Manual threshold management disabled for this deployment">
              <LockOutlinedIcon color="disabled" aria-label="Threshold configurations locked" />
            </Tooltip>
          }
        >
          Threshold configurations
        </SectionHeading>
        <Typography variant="body2" color="text.secondary">
          Configure the alert thresholds used by queue wait-time and area population evaluations.
          Each configuration is independent and can use only the units supported by its metric.
        </Typography>
      </Stack>
      {configs.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          Threshold configurations are not available from the Runtime API yet.
        </Typography>
      ) : (
        <Stack spacing={2}>
          {configs.map((config) => (
            <ThresholdConfigCard key={config.id} config={config} />
          ))}
        </Stack>
      )}
    </Stack>
  );
}
